const fetchMyStore = async (query) => {
  const API_TOKEN = "e0752c6eb73c6da5755041aa83792a39";
  return await fetch(
    "https://lorcana-girafull.myshopify.com/api/2024-04/graphql.json",
    {
      //[shop-name]にurlのショップ名を入力
      method: "POST",
      headers: {
        "Content-Type": "application/graphql",
        "X-Shopify-Storefront-Access-Token": API_TOKEN, //Storefront APIのアクセストークンを入力
      },
      body: query,
    }
  ).then((response) => response.json());
};

const getCollectionNewDate = async (handle) => {
  let result;
  const query = `{
    collectionByHandle(handle: "${handle}") {
      products(first: 1) {
        edges {
          node {
            createdAt
          }
        }
      }
    }
  }`;

  await fetchMyStore(query).then((response) => {
    const resDate =
      response.data.collectionByHandle.products.edges[0]?.node.createdAt;
    if (!resDate) return;
    const date = new Date(resDate);
    result = moment(date).format("MM月DD日 HH:mm");
  });
  return result;
};

const apiProductHtml = (item, sectionId, unit) => {
  const variants = item.variants;
  let activeIndex = 0;
  variants.edges.forEach((variant, index) => {
    if (variant.node.title === "A") activeIndex = 1;
  });
  const panelHtml = () => {
    let resultOptions = "";
    let resultValues = "";
    variants.edges.forEach((variant, index) => {
      if (variant.node.title === "A") activeIndex = 1;
      const pid = item.id.replace("gid://shopify/Product/", "");
      const id = variant.node.id.replace("gid://shopify/ProductVariant/", "");
      const price = Math.trunc(variant.node.price.amount);
      const compareAtPrice = Math.trunc(variant.node.compareAtPrice?.amount);
      resultOptions += `<div class="option ${index === activeIndex ? "active" : ""} ${
        variant.node.quantityAvailable ? "" : "disable"
      }" data-product-id="${pid}" data-variant-id="${id}">${
        variant.node.title
      }</div>`;

      resultValues += `<div class="value ${index === activeIndex ? "active" : ""}" id="variant-${pid}-${id}"><h4 class="price"><span class="current ${
        price < compareAtPrice ? "" : "big"
      }">${unit}${price.toLocaleString()}<small>（税込）</small></span>${
        price < compareAtPrice
          ? `<span class="old">${unit}${compareAtPrice.toLocaleString()}<small>（税込）</small></span>`
          : ""
      }
      </h4><product-form data-section-id="${sectionId}"><form method="post" action="/cart/add" id="quick-add-${id}" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form"><input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="id" value="${id}" class="product-variant-id">
      <button id="quick-add-${id}-submit" type="submit" name="add" class="product-form__submit hover-btn with-arrow ${
        variant.node.quantityAvailable ? "" : "disable"
      }">カートに入れる<link href="//lorcana-girafull.myshopify.com/cdn/shop/t/8/assets/component-loading-spinner.css?v=116724955567955766481711969061" rel="stylesheet" type="text/css" media="all"><div class="loading__spinner hidden"><svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div></button><input type="hidden" name="product-id" value="${pid}"><input type="hidden" name="section-id" value="${sectionId}"></form></product-form></div>`;
    });

    return {
      option: resultOptions,
      value: resultValues,
    };
  };

  const image = item.media.edges.length
    ? item.media.edges[0].node.image.url
    : "";

  return `<li class="product"><div class="card"><div class="card__inner"><div class="card__media"><a href="/products/${
    item.handle
  }"><img src="${image}" alt=""></a></div><div class="card__content"><a href="/products/${
    item.handle
  }"><h3 class="card__heading">${
    item.title
  }</h3></a><div class="variation-panel"><div class="variant-options">${
    panelHtml().option
  }</div><div class="variant-values">${
    panelHtml().value
  }</div></div></div></div></div></li>`;
};

const headerInit = () => {
  const header = document.querySelector("header");
  const hamburgerIcon = document.querySelector("header .hamburger");
  const drawer = document.querySelector("header .drawer");
  let menuOffset = header.getBoundingClientRect().bottom;
  window.addEventListener("scroll", () => {
    const rect = header.getBoundingClientRect();
    if (rect.top < window.innerHeight && rect.bottom >= 0) {
      let visibleHeight = 0;
      if (rect.top >= 0) {
        visibleHeight = Math.min(rect.height, window.innerHeight - rect.top);
      } else {
        visibleHeight = Math.min(rect.bottom, window.innerHeight);
      }
      menuOffset = visibleHeight;
    }
  });

  hamburgerIcon.addEventListener("click", () => {
    drawer.style.top = menuOffset + "px";
    drawer.style.height = window.innerHeight - menuOffset + "px";
    document.body.classList.toggle("body-lock");
    hamburgerIcon.classList.toggle("active");
    drawer.classList.toggle("open");
  });
  document
    .querySelector("header .header-search svg")
    .addEventListener("click", (event) => {
      document
        .querySelector("header .header-search form")
        .classList.toggle("active");
    });
};

const panelInit = () => {
  document.querySelectorAll(".variant-options .option").forEach((tab) => {
    tab.addEventListener("click", (event) => {
      const productId = event.target.dataset.productId;
      const variantId = event.target.dataset.variantId;
      const options = event.target.parentNode;
      const values = options.nextElementSibling;

      Array.from(options.children).forEach((option) => {
        if (option.dataset.variantId === variantId) {
          option.classList.add("active");
        } else {
          option.classList.remove("active");
        }
      });

      Array.from(values.children).forEach((value) => {
        if (value.id === `variant-${productId}-${variantId}`) {
          value.classList.add("active");
        } else {
          value.classList.remove("active");
        }
      });
    });
  });
};

const suggestInit = () => {
  const titleList = (data) => {
    const list = data.map((item) => item.node.title);
    const result = new Set(list);
    return Array.from(result);
  };
  const setQuery = (text) => {
    const query = `{
      products(first:250, query: "${text}", sortKey: RELEVANCE) {
        edges {
          node {
            handle,
            title
          }
        }
      }
    }`;
    return query;
  };

  const onSuggest = (id) => {
    const input = document.getElementById(id + "-input");
    if (!input) return;
    const suggest = new Awesomplete(input, {
      minChars: 1,
      autoFirst: false,
      maxItems: 10,
    });

    input.addEventListener("input", (event) => {
      document.body.classList.remove("body-lock");
      document.querySelector(".hamburger").classList.remove("active");
      document.querySelector(".drawer").classList.remove("open");
      fetchMyStore(setQuery(event.target.value)).then((response) => {
        const data = response.data.products.edges;
        suggest.list = titleList(data);
      });
    });

    input.addEventListener("awesomplete-select", (event) => {
      window.location.href = `/search?type=product&q=${event.text.value}`;
    });
  };

  onSuggest("suggestKv");
  onSuggest("suggestHeader");
  onSuggest("suggestSearchPage");
};

const similarInit = () => {
  const wrappers = document.querySelectorAll(".similar-list");
  wrappers.forEach((wrapper) => {
    const title = wrapper.getAttribute("data-title");
    const handle = wrapper.getAttribute("data-handle");
    const sectionId = wrapper.getAttribute("data-section-id");
    const unit = wrapper.getAttribute("data-price-unit");
    const searchName = title.split(" - ")[0];

    const query = `
    {
      products(first:5, query: "${searchName}") {
        edges {
          node {
            id,
            handle,
            title,
            tags,
            totalInventory,
            variants(first: 4) {
              edges {
                node {
                  sku,
                  id,
                  title,
                  price {
                    amount
                  }
                  quantityAvailable,
                  compareAtPrice {
                    amount
                  }
                }
              }
            }
            media(first: 10) {
              edges {
                node {
                  alt
                  ...mediaFieldsByType
                }
              }
            }
          }
        }
      }
    }
    fragment mediaFieldsByType on Media {
      ... on MediaImage {
        image {
          url
        }
      }
    }`;

    fetchMyStore(query).then((response) => {
      const items = response.data.products.edges
        .map((item) => item.node)
        .filter((item) => item.handle !== handle);
      if (!items.length) {
        wrapper.parentNode.parentNode.style.display = "none";
        return;
      }
      items.forEach((item) => {
        if (!item) return;
        wrapper.insertAdjacentHTML(
          "beforeend",
          apiProductHtml(item, sectionId, unit)
        );
      });
    });
  });
};

const checkItemsInit = () => {
  const wrappers = document.querySelectorAll(".check-items .check-list");

  wrappers.forEach((wrapper) => {
    const sectionId = wrapper.getAttribute("data-section-id");
    const unit = wrapper.getAttribute("data-price-unit");
    const handles = JSON.parse(localStorage.getItem("checkItems"));
    if (!handles.length) {
      wrapper.parentElement.parentElement.style.display = "none";
    }
    handles.forEach((handle) => {
      const query = `{
        productByHandle(handle: "${handle}") {
          id
          handle
          title
          tags
          totalInventory
          variants(first: 4) {
            edges {
              node {
                sku
                id
                title
                price {
                  amount
                }
                quantityAvailable
                compareAtPrice {
                  amount
                }
              }
            }
          }
          media(first: 10) {
            edges {
              node {
                alt
                ... on MediaImage {
                  image {
                    url
                  }
                }
              }
            }
          }
        }
      }`;
      fetchMyStore(query).then((response) => {
        const item = response.data.productByHandle;
        if (!item) return;
        wrapper.insertAdjacentHTML(
          "beforeend",
          apiProductHtml(item, sectionId, unit)
        );
      });
    });
  });
};

const productImgInit = () => {
  const imageTags = document.querySelectorAll(".main-product .item-img");
  const popup = document.getElementById("imgPopup");
  let width = window.innerWidth;

  const togglePreview = () => {
    document.querySelector(".main-product").classList.toggle("preview");
  };

  const openPopup = (event) => {
    popup.querySelector(
      ".inner"
    ).innerHTML = `<img src="${event.target.src}" />`;
    popup.classList.add("active");
  };

  const closePopup = () => {
    document.getElementById("imgPopup").classList.remove("active");
  };

  const resizeHandler = () => {
    width = window.innerWidth;
    imageTags.forEach((imgTag) => {
      imgTag.removeEventListener("click", togglePreview);
      imgTag.removeEventListener("click", openPopup);
      popup.removeEventListener("click", closePopup);
      document.querySelector(".main-product").classList.remove("preview");
      closePopup();
      if (width > 1300) {
        imgTag.addEventListener("click", togglePreview);
      } else {
        imgTag.addEventListener("click", openPopup);
        popup.addEventListener("click", closePopup);
      }
    });
  };

  window.addEventListener("resize", resizeHandler);
  resizeHandler();
};

const telFormValidation = () => {
  const inputs = Array.from(document.querySelectorAll("input[type=tel]"));
  inputs.forEach((input) => {
    input.addEventListener("input", (e) => {
      e.target.value = e.target.value.replace(/[^0-9]/g, "");
    });
  });
};

window.addEventListener("load", () => {
  headerInit();
  suggestInit();
  similarInit();
  checkItemsInit();
  productImgInit();
  panelInit();
  telFormValidation();
  const menuList = document.querySelectorAll(".menu-box .panel-list > li");
  menuList.forEach((menu) => {
    menu.addEventListener("click", (event) => {
      event.target.classList.toggle("active");
      const child = event.target.querySelector(".dropdown-menu");
      child.classList.toggle("open");
    });
  });
});

const main = document.querySelector("main > div");
const observer = new MutationObserver(() => {
  panelInit();
});

observer.observe(main, { subtree: true, childList: true });
